import { graphql } from "gql.tada";

export const ProductMotionSlidesSectionById = graphql(
  `
    query ProductMotionSlidesSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      productMotionSlidesSection(id: $id, preview: $preview, locale: $locale) {
        ...ProductMotionSlidesSectionFragment
      }
    }
    fragment ProductMotionSlidesSectionFragment on ProductMotionSlidesSection {
      title
      superTitle
      slidesCollection(limit: 3) {
        items {
          title
          subtitle
          ctaLink {
            text
            isExternal
            url
            pageReference: reference {
              __typename
              ... on Page {
                slug
                theme {
                  palette
                  foreground
                  background
                }
              }
              ... on ArticlePage {
                slug
              }
            }
          }
          mediaContentCollection(limit: 4) {
            items {
              url
            }
          }
        }
      }
    }
  `
);
